// WooCommerce Header Cart Update and Sidebar Cart - Vanilla JS
import { ready, $, $$, slideDown, slideUp } from "./utils.js";

ready(() => {
  // =========================================================================
  // CART SIDEBAR FUNCTIONALITY
  // =========================================================================
  function openCartSidebar() {
    const sidebar = $("#cart-sidebar");
    if (sidebar) sidebar.classList.add("open");
    document.body.classList.add("cart-sidebar-open");
  }

  function closeCartSidebar() {
    const sidebar = $("#cart-sidebar");
    if (sidebar) sidebar.classList.remove("open");
    document.body.classList.remove("cart-sidebar-open");
  }

  // =========================================================================
  // SHOP FILTERS - Mobile Drawer with Accessibility
  // =========================================================================
  function openShopFilters() {
    const overlay = $("#shop-filters-overlay");
    const toggle = $("#shop-filters-toggle");
    if (!overlay || !toggle) return;

    overlay.classList.add("active");
    toggle.classList.add("active");
    toggle.setAttribute("aria-expanded", "true");
    document.body.classList.add("shop-filters-open");

    setTimeout(() => {
      const focusable = overlay.querySelector(
        "input, button, select, textarea, a[href]",
      );
      if (focusable) focusable.focus();
    }, 300);
  }

  function closeShopFilters() {
    const overlay = $("#shop-filters-overlay");
    const toggle = $("#shop-filters-toggle");
    if (!overlay || !toggle) return;

    overlay.classList.remove("active");
    toggle.classList.remove("active");
    toggle.setAttribute("aria-expanded", "false");
    document.body.classList.remove("shop-filters-open");

    toggle.focus();
  }

  document.addEventListener("click", (e) => {
    const toggle = e.target.closest("#shop-filters-toggle");
    if (!toggle) return;
    e.preventDefault();
    if (toggle.classList.contains("active")) {
      closeShopFilters();
    } else {
      openShopFilters();
    }
  });

  document.addEventListener("click", (e) => {
    if (e.target.closest(".shop-filters-close")) {
      e.preventDefault();
      closeShopFilters();
    }
  });

  document.addEventListener("click", (e) => {
    const overlay = e.target.closest(".shop-filters-overlay");
    if (overlay && e.target === overlay) {
      closeShopFilters();
    }
  });

  document.addEventListener("keydown", (e) => {
    const overlay = $("#shop-filters-overlay");
    if (e.keyCode === 27 && overlay && overlay.classList.contains("active")) {
      closeShopFilters();
    }
  });

  // =========================================================================
  // ACTIVE FILTERS - Display & Clear Functionality
  // =========================================================================
  function populateActiveFilters() {
    const urlParams = new URLSearchParams(window.location.search);
    const container = $(".active-filters-pills");

    if (!container) return;

    container.innerHTML = "";
    let hasFilters = false;

    const minPrice = urlParams.get("min_price");
    const maxPrice = urlParams.get("max_price");
    if (minPrice || maxPrice) {
      hasFilters = true;
      const priceText =
        minPrice && maxPrice
          ? `$${minPrice} - $${maxPrice}`
          : minPrice
            ? `Over $${minPrice}`
            : `Under $${maxPrice}`;

      container.insertAdjacentHTML(
        "beforeend",
        `
        <div class="filter-pill" data-filter="price">
          <span class="filter-pill-label">Price:</span>
          <span>${priceText}</span>
          <button class="filter-pill-remove" aria-label="Remove price filter">&times;</button>
        </div>
      `,
      );
    }

    const category = urlParams.get("product_cat");
    if (category) {
      hasFilters = true;
      container.insertAdjacentHTML(
        "beforeend",
        `
        <div class="filter-pill" data-filter="product_cat" data-value="${category}">
          <span class="filter-pill-label">Category:</span>
          <span>${category.replace("-", " ")}</span>
          <button class="filter-pill-remove" aria-label="Remove category filter">&times;</button>
        </div>
      `,
      );
    }

    urlParams.forEach((value, key) => {
      if (key.startsWith("filter_")) {
        hasFilters = true;
        const filterName = key.replace("filter_", "").replace("_", " ");
        container.insertAdjacentHTML(
          "beforeend",
          `
          <div class="filter-pill" data-filter="${key}" data-value="${value}">
            <span class="filter-pill-label">${filterName}:</span>
            <span>${value}</span>
            <button class="filter-pill-remove" aria-label="Remove ${filterName} filter">&times;</button>
          </div>
        `,
        );
      }
    });

    const activeContainer = $(".active-filters-container");
    if (activeContainer) {
      activeContainer.style.display = hasFilters ? "" : "none";
    }
  }

  document.addEventListener("click", (e) => {
    const removeBtn = e.target.closest(".filter-pill-remove");
    if (!removeBtn) return;
    e.preventDefault();

    const pill = removeBtn.closest(".filter-pill");
    if (!pill) return;
    const filterType = pill.dataset.filter;

    const url = new URL(window.location);

    if (filterType === "price") {
      url.searchParams.delete("min_price");
      url.searchParams.delete("max_price");
    } else {
      url.searchParams.delete(filterType);
    }

    window.location.href = url.toString();
  });

  document.addEventListener("click", (e) => {
    if (!e.target.closest(".clear-all-filters")) return;
    e.preventDefault();
    const baseUrl = window.location.origin + window.location.pathname;
    window.location.href = baseUrl;
  });

  populateActiveFilters();

  // =========================================================================
  // COLLAPSIBLE FILTER WIDGETS
  // =========================================================================
  document.addEventListener("click", (e) => {
    const title = e.target.closest(".shop-sidebar .widget-title");
    if (!title) return;

    const widget = title.parentElement;
    if (!widget) return;
    const content = widget.querySelector("ul, form, .price_slider_wrapper");

    title.classList.toggle("collapsed");

    if (content) {
      const isHidden =
        content.style.display === "none" ||
        window.getComputedStyle(content).display === "none";
      if (isHidden) {
        slideDown(content, 300);
      } else {
        slideUp(content, 300);
      }
    }
  });

  // =========================================================================
  // STICKY CONTROLS BAR ON SCROLL (Mobile)
  // =========================================================================
  const controlsBar = $(".shop-controls-bar");
  if (controlsBar && window.innerWidth < 768) {
    window.addEventListener("scroll", () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 200) {
        controlsBar.classList.add("is-sticky");
      } else {
        controlsBar.classList.remove("is-sticky");
      }
    });
  }

  // =========================================================================
  // PRODUCT CARD QUICK ACTIONS (Wishlist, Quick View)
  // =========================================================================
  document.addEventListener("click", (e) => {
    const button = e.target.closest(".quick-action-wishlist");
    if (!button) return;
    e.preventDefault();

    button.classList.toggle("active");

    const icon = button.querySelector("svg path");
    if (icon) {
      icon.setAttribute(
        "fill",
        button.classList.contains("active") ? "currentColor" : "none",
      );
    }
  });

  document.addEventListener("click", (e) => {
    const button = e.target.closest(".quick-action-view");
    if (!button) return;
    e.preventDefault();
    const productId = button.dataset.productId;

    // Trigger quick view plugin (jQuery event for plugin compatibility)
    if (window.jQuery) {
      window.jQuery(document.body).trigger("woo_quick_view", [productId]);
    } else {
      document.body.dispatchEvent(
        new CustomEvent("woo_quick_view", { detail: { productId } }),
      );
    }
  });

  // =========================================================================
  // LAZY LOADING IMAGES
  // =========================================================================
  if ("IntersectionObserver" in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target;
          const src = img.getAttribute("data-src");
          if (src) {
            img.setAttribute("src", src);
            img.removeAttribute("data-src");
            img.classList.add("loaded");
          }
          observer.unobserve(img);
        }
      });
    });

    $$("img[data-src]").forEach((img) => imageObserver.observe(img));
  }

  // =========================================================================
  // LOAD MORE BUTTON
  // =========================================================================
  let loadMorePage = 2;

  document.addEventListener("click", async (e) => {
    const button = e.target.closest(".load-more-button");
    if (!button) return;
    e.preventDefault();

    const productsContainer = $("ul.products");
    if (!productsContainer || typeof ajax_variable === "undefined") return;

    button.classList.add("loading");
    button.disabled = true;

    try {
      const response = await fetch(ajax_variable.ajax_url, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          action: "load_more_products",
          page: loadMorePage,
          query: ajax_variable.query_vars || "",
        }).toString(),
      });
      const data = await response.json();

      if (data.success && data.data && data.data.products) {
        productsContainer.insertAdjacentHTML("beforeend", data.data.products);
        loadMorePage++;
        if (!data.data.has_more) {
          const parent = button.parentElement;
          if (parent) parent.style.display = "none";
        }
      }
    } catch (err) {
      console.error("Load more failed:", err);
    } finally {
      button.classList.remove("loading");
      button.disabled = false;
    }
  });

  // =========================================================================
  // CART FUNCTIONALITY
  // =========================================================================
  document.addEventListener("click", (e) => {
    if (e.target.closest(".woo-cart-icon, .mobile-woo-cart-icon")) {
      e.preventDefault();
      openCartSidebar();
    }
  });

  document.addEventListener("click", (e) => {
    if (e.target.closest(".cart-sidebar-close, .cart-sidebar-overlay")) {
      closeCartSidebar();
    }
  });

  document.addEventListener("keydown", (e) => {
    const sidebar = $("#cart-sidebar");
    if (e.keyCode === 27 && sidebar && sidebar.classList.contains("open")) {
      closeCartSidebar();
    }
  });

  // Remove from cart in sidebar
  document.addEventListener("click", async (e) => {
    const removeButton = e.target.closest(
      ".cart-sidebar .remove_from_cart_button",
    );
    if (!removeButton) return;
    e.preventDefault();

    if (typeof wc_add_to_cart_params === "undefined") return;

    const cartItemKey = removeButton.dataset.cart_item_key;
    const url = wc_add_to_cart_params.wc_ajax_url
      .toString()
      .replace("%%endpoint%%", "remove_from_cart");

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ cart_item_key: cartItemKey }).toString(),
      });
      const data = await response.json();
      if (data && data.fragments) {
        updateCartSidebar();
        updateHeaderCartCount();
      }
    } catch (err) {
      console.error("Remove from cart failed:", err);
    }
  });

  function getAjaxUrl() {
    if (typeof ajax_variable !== "undefined" && ajax_variable.ajax_url) {
      return ajax_variable.ajax_url;
    }
    if (
      typeof wc_add_to_cart_params !== "undefined" &&
      wc_add_to_cart_params.ajax_url
    ) {
      return wc_add_to_cart_params.ajax_url;
    }
    return "/wp-admin/admin-ajax.php";
  }

  async function updateCartSidebar() {
    try {
      const response = await fetch(getAjaxUrl(), {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          action: "get_sidebar_cart_content",
        }).toString(),
      });
      const data = await response.json();
      if (!data.success) return;

      const body = $("#cart-sidebar .cart-sidebar-body");
      if (body) body.innerHTML = data.data.content;

      const footer = $("#cart-sidebar .cart-sidebar-footer");
      if (footer) {
        if (data.data.footer) {
          footer.innerHTML = data.data.footer;
          footer.style.display = "";
        } else {
          footer.style.display = "none";
        }
      }
    } catch (err) {
      console.error("Cart sidebar update failed:", err);
    }
  }

  async function updateHeaderCartCount() {
    try {
      const response = await fetch(getAjaxUrl(), {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ action: "get_cart_count" }).toString(),
      });
      const data = await response.json();
      if (!data.success) return;

      const cartCount = data.data.count;
      const cartCountEl = $(".cart-count");
      const mobileCartEl = $(".mobile-woo-cart-icon span");

      if (cartCountEl) {
        cartCountEl.textContent = cartCount;
      } else {
        const cartIcon = $(".woo-cart-icon");
        if (cartIcon) {
          cartIcon.insertAdjacentHTML(
            "beforeend",
            `<span class="cart-count">${cartCount}</span>`,
          );
        }
      }

      if (mobileCartEl) {
        mobileCartEl.textContent = `Shopping Cart (${cartCount})`;
      }
    } catch (err) {
      console.error("Header cart count update failed:", err);
    }
  }

  // WooCommerce fires these as jQuery events. Listen via jQuery if it's present;
  // otherwise listen as DOM custom events (won't fire from WC core, but harmless).
  const wcEvents = [
    "added_to_cart",
    "updated_wc_div",
    "wc_fragments_refreshed",
  ];

  if (window.jQuery) {
    window.jQuery(document.body).on("added_to_cart", () => {
      updateHeaderCartCount();
      updateCartSidebar();
      openCartSidebar();
    });
    window.jQuery(document.body).on("updated_wc_div wc_fragments_refreshed", () => {
      updateHeaderCartCount();
      updateCartSidebar();
    });
  } else {
    wcEvents.forEach((evt) => {
      document.body.addEventListener(evt, () => {
        updateHeaderCartCount();
        updateCartSidebar();
        if (evt === "added_to_cart") openCartSidebar();
      });
    });
  }

  // Standard AJAX add to cart forms
  $$("form.cart").forEach((form) => {
    form.addEventListener("submit", () => {
      const button = form.querySelector(".single_add_to_cart_button");
      if (button && button.classList.contains("ajax_add_to_cart")) {
        setTimeout(() => {
          updateHeaderCartCount();
          updateCartSidebar();
          openCartSidebar();
        }, 1000);
      }
    });
  });

  $$(".ajax_add_to_cart").forEach((btn) => {
    btn.addEventListener("click", () => {
      setTimeout(() => {
        updateHeaderCartCount();
        updateCartSidebar();
        openCartSidebar();
      }, 1000);
    });
  });
});
